import { StationType, TransitionStationData } from 'pages/Map/types';
import { BaseStation } from '../BaseStation';

export class TransitionStation extends BaseStation {
    type: StationType.Transition;

    constructor(station: TransitionStationData) {
        const { type, ...baseStationData } = station;
        super(baseStationData);

        this.type = type;
    }

    getType() {
        return this.type;
    }
}
